"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { useAuth } from "@/lib/auth-context";

export default function BrokersMenu() {
  const { user } = useAuth();
  const pathname = usePathname();
  const active = pathname.startsWith("/brokers") || pathname.startsWith("/schwab");

  if (!user) return null;

  return (
    <Link
      href="/brokers/schwab"
      className={`transition-colors select-none ${
        active
          ? "text-white [text-shadow:0_0_8px_#fff,0_0_16px_#fff,0_0_30px_var(--color-accent),0_0_50px_var(--color-accent)]"
          : "text-muted hover:text-accent"
      }`}
    >
      Brokers
    </Link>
  );
}
